import create from 'zustand';
import { devtools } from 'zustand/middleware';

interface BaseStoreValues {
  isSending: boolean;
}

export type ServiceInspectionStore = BaseStoreValues & {
  setIsSending: (isSending: boolean) => void;
  reset: () => void;
};

const INITIAL_STATE: BaseStoreValues = {
  isSending: false,
};

/** Store for ServiceInspection */
export const useServiceInspectionStore = create<ServiceInspectionStore>(
  devtools(
    set => ({
      ...INITIAL_STATE,

      setIsSending: (isSending: boolean) => {
        set(() => ({ isSending }));
      },

      reset: () => {
        set(() => INITIAL_STATE);
      },
    }),
    'ServiceInspectionStore',
  ),
);
